import { reactive } from 'vue'

const ERRORS = {
  CREDENTIALS: 'ERROR_CREDENTIALS',
  LOAD_PROJECT: 'ERROR_LOAD_PROJECT',
  CREATE_PROJECT: 'ERROR_CREATE_PROJECT'
}

const ERRORS_INVERSE: { [key: string]: string } = {}
Object.entries(ERRORS).forEach((val: [string, string]) => (ERRORS_INVERSE[val[1]] = val[0]))

export { ERRORS, ERRORS_INVERSE }

export type ErrorData = {
  message: string
  customMessage?: string
  stack?: string
  timestamp: string
  severity: ErrorSeverity
  componentInfo?: {
    component?: string
    info?: string
    source?: string
  } | null
  deviceInfo: DeviceInfo
  browserInfo: {
    userAgent: string
    viewport: string
    url: string
    referrer: string
    language: string
  }
  e2Info?: E2Info
  performance?: {
    memory?: MemoryInfo
  }
  additionalContext?: Record<string, any>
  [key: string]: any
}

export type FlattenedErrorData = {
  [key: string]: any
}

export type ErrorState = {
  hasError: boolean
  currentError: ErrorData | null
  errorStack: ErrorData[]
  showDialog: boolean
}

// Enum for error severity levels
export enum ErrorSeverity {
  INFO = 'info',
  PERFORMANCE = 'performance',
  WARNING = 'warning',
  ERROR = 'error',
  CRITICAL = 'critical'
}

export type E2Info = {
  themeId: string
  produktId: string | undefined
  coreVersion: string
  clientVersion: string
  sessionId: string | undefined
}

export type DeviceInfo = {
  os: string
  platform: string
  browser: string
  browserVersion: string
  userAgent: string
  isMobile: boolean
  screenResolution: string
  devicePixelRatio: number
}

export type MemoryInfo = {
  jsHeapSizeLimit?: number
  totalJSHeapSize?: number
  usedJSHeapSize?: number
}

export type PerformanceTimingInfo = {
  navigationStart?: number
  loadEventEnd?: number
  domComplete?: number
  firstContentfulPaint?: number
}
